/* eslint-disable */
// lint to be fixed in this ticket: https://lastbrand.atlassian.net/browse/ECOMP-3295
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/order */
/*
 * TODO: IMPORTANT IMPORTANT IMPORTANT
 * DO NOT CHANGE THE ORDER OF IMPORTS HERE IT WILL BREAK THE BUILD
 *
 * import { LOCAL_STORAGE_NEW_CART_ID_KEY } from '../../../services/checkoutService/offshopify.constants'
 * import { isInNewCartExperiment } from './new-cart-exp-helper'
 * import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'
 */
import { LOCAL_STORAGE_NEW_CART_ID_KEY } from '../../../services/checkoutService/offshopify.constants'
import { isInNewCartExperiment } from './new-cart-exp-helper'
import { getCartAuthCodeFromHeader } from '../../../services/cartService/cart.service.helper'

import { CONFIG_BUILD_ENV } from '@src/config/env'
import { ShopifyEdgeNode } from '@src/quince-site-common/src/domains/shopify/ShopifyEdgeNodeWrapper'
import { LineItemDetails } from '@src/quince-site-common/src/organisms/appLayout/molecules/cartPopUp/cart.helper'
import {
  Cart,
  CartLineItem,
  PromoAllocation,
} from '@src/quince-site-common/src/services/cartService/cart.service.types'
import { CAVIAR_SHIPDATE } from '@src/quince-site-common/src/utils/constants'

import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { extractShopifyCheckoutToken } from '@src/telemetry/integrations/InternalAnalytics'

import IShopifyCheckout, {
  IShopifyCheckoutLineItem,
  IShopifyLineItemDiscountAllocation,
  INVENTORY_STATUS,
} from '../../../domains/shopify/ShopifyCheckout'
import { decodeShopifyIdFromGraphqlIdResponse } from '../../../utils/decodeShopifyIdFromGraphqlIdResponse'
import { getPreOrderShippingDate } from '../../shopify/shopify-utils'
import { getStorage } from '@src/utils/enhancedStorage'

export function getLineItem(shopifyCheckout: IShopifyCheckout | Cart) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (shopifyCheckout as Cart)?.lineItems
  }
  return (shopifyCheckout as IShopifyCheckout)?.lineItems?.edges
}

export function getLineItemId(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantId
  }
  return decodeShopifyIdFromGraphqlIdResponse(
    (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.product?.id,
  )
}

export function getShopifyVariantIdFromEdge(edge: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (edge as CartLineItem)?.productMetaData?.shopifyVariantId
  }
  return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.id
}

export function getShopifyProductId(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.productMetaData?.shopifyProductId
  }
  return decodeShopifyIdFromGraphqlIdResponse(
    (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.product?.id,
  )
}

// export function getProductIDFromProduct(lineItem: any) {
//   const inExperiment = isInNewCartExperiment()
//   if (inExperiment) {
//     return lineItem?.id
//   }
//   return lineItem?.shopifyProductId
// }

export function getSelectedOptionsFromLineItem(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.productMetaData?.options
  }
  return (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.selectedOptions
}

export function getLineItemsSubtotalPriceAmount(node: IShopifyCheckout | Cart) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (node as Cart)?.cartCostSummary?.subTotalAmount
  }
  return (node as IShopifyCheckout)?.lineItemsSubtotalPrice?.amount
}

export function getSubtotalPriceV2(node: IShopifyCheckout | Cart) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (node as Cart)?.cartCostSummary?.totalAmount
  }
  return (node as IShopifyCheckout)?.subtotalPriceV2?.amount
}

export function getLineItemEdges(node: IShopifyCheckout | Cart) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (node as Cart)?.lineItems
  }
  return (node as IShopifyCheckout)?.lineItems?.edges
}

export function getSaveForLaterItems(node: IShopifyCheckout | Cart) {
  return (node as Cart)?.saveForLaterItems
}

export function getOutOfStockItems(node: IShopifyCheckout | Cart) {
  return (node as Cart)?.outOfStockLineItems || []
}

export function getProductID(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.productId
  }
  return decodeShopifyIdFromGraphqlIdResponse(lineItem?.variant?.product?.id || lineItem?.node?.variant?.product?.id)
}

export function getVariantId(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.variantId
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant?.id
}

export function getShopifyVariantId(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.productMetaData?.shopifyVariantId
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant?.id
}

export function getVariantSelectedOptions(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return lineItem?.productMetaData?.options
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant?.selectedOptions
}

export function getVariantIdFromEdge(edge: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (edge as CartLineItem)?.variantId
  }
  return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.id
}

export function getVariantProductIdFromEdge(edge: ShopifyEdgeNode<IShopifyCheckoutLineItem> | any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return edge?.lineItem?.variantId
  }
  return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.product?.id
}

export function getVariantProductId(node: IShopifyCheckoutLineItem | any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return node?.lineItem?.variantId
  }
  return (node as IShopifyCheckoutLineItem)?.variant?.product?.id
}

export function getIdFromEdge(edge: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (edge as CartLineItem).id
  }
  return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.id
}

export function getQuantityFromEdge(edge: CartLineItem | ShopifyEdgeNode<IShopifyCheckoutLineItem>) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (edge as CartLineItem)?.quantity
  }
  return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.quantity
}

export function getLineItemFromEdge(edge: CartLineItem | ShopifyEdgeNode<IShopifyCheckoutLineItem>) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return edge as CartLineItem
  }
  return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node
}

export function getLineItemDetails(lineItems: CartLineItem[]) {
  return lineItems.reduce((acc: Record<string, LineItemDetails>, curr) => {
    const { variantId: internalVariantId, productId: internalProductId, price } = curr.variantMetaData || {}
    return {
      ...acc,
      [curr.variantId]: {
        productLink: curr.slug ? `/${curr.slug}` : '',
        internalVariantId,
        internalProductId,
        price,
      },
    }
  }, {})
}

export function getIsAnyItemOutOfStock(lineItems: any[]) {
  return lineItems?.some(
    lineItem =>
      lineItem?.inventoryStatus === INVENTORY_STATUS.OUT_OF_STOCK ||
      lineItem?.inventoryStatus === INVENTORY_STATUS.PARTIAL_OUT_OF_STOCK,
  )
}

export function getQuantityAvailableFromLineItem(
  lineItem: IShopifyCheckoutLineItem | CartLineItem,
  _inExperiment?: boolean,
) {
  const inExperiment = _inExperiment ?? isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.inventoryData?.available
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant?.quantityAvailable
}

export function getProductFromLineItem(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant.product
}

export function getProductTitleFromLineItem(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.productTitle
  }
  return (lineItem as IShopifyCheckoutLineItem)?.title
}

export function getVariantTitleFromLineItem(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.variantTitle
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant?.title
}

export function getCustomAttributes(lineItem?: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.attributes || []
  }
  return (lineItem as IShopifyCheckoutLineItem)?.customAttributes
}

export function getProductImageFromLineItem(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.imageUrl
  }
  return (lineItem as IShopifyCheckoutLineItem)?.variant?.image?.transformedSrc
}

export function getPreOrderShippingData(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.imageUrl
  }
  const { variant } = lineItem as IShopifyCheckoutLineItem
  return variant ? getPreOrderShippingDate(variant) : ''
}

export function getShopifyVariantMetaField(lineItem: IShopifyCheckoutLineItem | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  const quantityAvailable = getQuantityAvailableFromLineItem(lineItem, inExperiment)
  if (inExperiment) {
    const { inventoryData } = lineItem as CartLineItem
    return {
      shopifyVariantMetaField: inventoryData,
      shippingDate: isLineItemCaviar(lineItem) ? CAVIAR_SHIPDATE : inventoryData?.tags?.preOrderShippingDate,
      quantityAvailable,
    }
  }
  const { variant } = lineItem as IShopifyCheckoutLineItem
  return {
    shopifyVariantMetaField: variant,
    shippingDate: variant ? getPreOrderShippingDate(variant) : '',
    quantityAvailable,
  }
}

export function getVariantPrice(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.price
  }
  return (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.priceV2?.amount
}

// export function getQuantityForUpdate(edge: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
//   const inExperiment = isInNewCartExperiment()
//   if (inExperiment) {
//     return edge.node.quantity
//   }
//   return (edge as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.quantity
// }

export function getProductTitleFromNode(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.productTitle
  }
  return (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant.product.title
}

export function getVariantTitleFromNode(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.variantTitle
  }
  return (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.title
}

export function getVariantSkuFromNode(lineItem: ShopifyEdgeNode<IShopifyCheckoutLineItem> | CartLineItem) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (lineItem as CartLineItem)?.variantMetaData?.variantTitle
  }
  return (lineItem as ShopifyEdgeNode<IShopifyCheckoutLineItem>)?.node?.variant?.sku
}

export function getVarientId(variant: any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return variant?.id
  }
  return variant?.shopifyVariantId
}

export function isEqualId(id: string, filterIdForVariant: string) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return id === filterIdForVariant
  }
  return id.includes(filterIdForVariant)
}

export function getCartIDAndAuth(inExperiment?: boolean) {
  const _inExperiment = inExperiment ?? isInNewCartExperiment()
  if (!_inExperiment) {
    return {
      cartID: null,
      authCode: null,
    }
  }
  return {
    cartID: isBrowser()
      ? window.localStorage.getItem(LOCAL_STORAGE_NEW_CART_ID_KEY)
      : null,
    authCode: getCartAuthCodeFromHeader(),
  }
}

export const getCheckoutToken = (): string => {
  const inNewCartExperiment = isInNewCartExperiment()
  const { cartID } = getCartIDAndAuth()
  const checkoutToken = inNewCartExperiment ? cartID : extractShopifyCheckoutToken()
  return checkoutToken ?? ''
}

export function getCreatedAt(lineItem: CartLineItem, lineItemCreatedAtObj: any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return lineItem?.createdAt
  }
  return lineItemCreatedAtObj ? Number(lineItemCreatedAtObj.value) : undefined
}

export function getDiscountAllocations(
  lineItem: IShopifyCheckoutLineItem | CartLineItem,
): IShopifyLineItemDiscountAllocation[] | PromoAllocation[] {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (
      (lineItem as CartLineItem)?.costSummary?.promoAllocations.filter(
        promoAllocation => promoAllocation.promoType === 'MONEY_DISCOUNT',
      ) || []
    )
  }
  return (lineItem as IShopifyCheckoutLineItem)?.discountAllocations
}

export function getDiscountTitle(allocation: IShopifyLineItemDiscountAllocation | PromoAllocation) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (allocation as PromoAllocation)?.promoCode
  }
  return (allocation as IShopifyLineItemDiscountAllocation)?.discountApplication?.title
}

export function getDiscountAmount(
  allocation: IShopifyLineItemDiscountAllocation | PromoAllocation,
  baseValue?: number,
) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return (allocation as PromoAllocation)?.amount
  }
  return baseValue ?? (allocation as IShopifyLineItemDiscountAllocation)?.allocatedAmount?.amount
}

export function getShopifyProductIdForLineItem(lineItem: any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return lineItem?.productMetaData?.shopifyProductId
  }
  return decodeShopifyIdFromGraphqlIdResponse(lineItem?.variant?.product?.id)
}

export function getSwatchesId(lineItem: any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return lineItem?.variantId
  }
  return lineItem?.variant?.id?.split('/').pop()
}
export function getSwatchesIdFromLineItem(lineItem: any) {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return lineItem?.variantId
  }
  return lineItem?.node?.variant?.id?.split('/').pop()
}
export const getpayloadForRemoveLineItems = (lineItem: any) => {
  const inExperiment = isInNewCartExperiment()
  if (inExperiment) {
    return {
      lineItemId: getIdFromEdge(lineItem),
      adjustment: -1,
    }
  }
  return getIdFromEdge(lineItem)
}

const isLineItemCaviar = (lineItem: CartLineItem) => {
  // Not considering the experiment as we are in 100% offshopify
  const productId = lineItem?.productMetaData?.productId

  if (CONFIG_BUILD_ENV === 'qa') return productId == 16650
  return productId == 6522
}

/* eslint-enable */
